import { useMutation } from '@tanstack/react-query';
import { camelizeKeys, decamelizeKeys } from 'humps';

import { useApiClient } from '../../../hooks';

const useUpdateSpaceMutation = (accessToken, organizationId) => {
  const apiClient = useApiClient(accessToken);
  const mutation = useMutation(({ id, data }) =>
    apiClient
      .patch(`/chat/spaces/${id}?organization_id=${organizationId}`, decamelizeKeys(data))
      .then(camelizeKeys)
  );

  return mutation;
};

export { useUpdateSpaceMutation };
